module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-symphony.c8d5a8f8.jpg";